import {ListItem, ListItemIcon, ListItemText} from '@material-ui/core';
import React from 'react';
import {Link} from 'react-router-dom';
import {HashLink} from 'react-router-hash-link';
import Show from './utils/Show';

const navBarOffset = -64;
const scroll = el => {
    const location = el.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    let goTo = location + offset;
    if (offset > location) {
        // We're scrolling up so the app bar will be present
        goTo = goTo + navBarOffset;
    }
    window.scrollTo({top: goTo, behavior: 'smooth'});
};

function ListItemLink(props) {
    const {icon = null, primary, to = '', href, selected, onClick} = props;

    const CustomLink = React.useMemo(
        () =>
            React.forwardRef((linkProps, ref) => {
                if (href) {
                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                    return <a ref={ref} href={href} {...linkProps} />;
                }
                if (to.includes('#')) {
                    return (
                        <HashLink
                            ref={ref}
                            to={to}
                            scroll={scroll}
                            {...linkProps}
                        />
                    );
                }
                return <Link ref={ref} to={to} {...linkProps} />;
            }),
        [to, href]
    );

    return (
        <li>
            <ListItem
                button
                component={CustomLink}
                selected={selected}
                onClick={onClick}
            >
                <Show condition={Boolean(icon)}>
                    <ListItemIcon>{icon}</ListItemIcon>
                </Show>
                <ListItemText primary={primary} />
            </ListItem>
        </li>
    );
}

const ListItemButton = props => {
    const {icon, primary, selected, onClick} = props;
    return (
        <li>
            <ListItem button selected={selected} onClick={onClick}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={primary} />
            </ListItem>
        </li>
    );
};

export default ListItemLink;
export {ListItemButton, ListItemLink};
